import React, { Component, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { styled, useTheme, keyframes } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import SplitPane, { Pane } from 'split-pane-react-uxrd';
import 'split-pane-react-uxrd/esm/themes/default.css';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ClearIcon from '@mui/icons-material/Clear';
import UndoIcon from '@mui/icons-material/Undo';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Skeleton from '@mui/material/Skeleton';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { InternalLinkChooserDialog } from "../../document/link-chooser";
import debounce from 'lodash.debounce';

import { UserInfo, netGet, netPost, netPostExt, netFetch, keycloak } from "../../network";

import * as XUI from '../xxeclient/xui.js';
import * as XXE from '../xxeclient/xxeclient.js';
import { XMLEditorWrapper } from "./wrapper";


import * as DB from '../xxeclient/docbook.js';
// some issue with latest react if these are in other folder, something odd with relative paths,
// so moved all resources from ../xxeclient
import './xui.css';
import './xxeclient.css';
import './docbook.css';

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

function decimalToHexString(number, padding)
{
  if (number < 0)
  {
    number = 0xFFFFFFFF + number + 1;
  }

  let hex = number.toString(16).toUpperCase();
  padding = typeof (padding) === "undefined" || padding === null ? 2 : padding;

  while (hex.length < padding) {
    hex = "0" + hex;
  }

  return hex;
}

function getRandomKey8() {
  const n = getRandomInt(0xFFFFFFFF);
  return decimalToHexString(n, 8);
}

function getRandomKey7() {
   const n = getRandomInt(0xFFFFFFF);
  return decimalToHexString(n, 7);
}




// const LazyEditor = React.lazy(() => import('../xxeclient/xxeclient.js'));


const SAMPLE1 = 
`<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE article PUBLIC "-//OASIS//DTD DocBook XML V4.5//EN"
"http://www.oasis-open.org/docbook/xml/4.5/docbookx.dtd">
<article lang="en-US" status="draft">
  <title>DocBook Table Support</title>

  <sect1 id="examples">
    <title>Examples found in <citetitle>DocBook: The Definitive
    Guide</citetitle></title>

    <table frame="all">
      <title>Sample Table</title>

      <tgroup align="left" cols="5" colsep="1" rowsep="1">
        <colspec colname="c1"/>

        <colspec colname="c2"/>

        <colspec colname="c3"/>

        <colspec colname="c5" colnum="5" colwidth="2*"/>

        <spanspec align="center" nameend="c2" namest="c1" spanname="hspan"/>

        <spanspec align="center" nameend="c3" namest="c2" spanname="bspan"/>

        <thead>
          <row>
            <entry spanname="hspan">Horizontal Span</entry>

            <entry>a3</entry>

            <entry>a4</entry>

            <entry>a5</entry>
          </row>
        </thead>

        <tfoot>
          <row>
            <entry>f1</entry>

            <entry>f2</entry>

            <entry>f3</entry>

            <entry>f4</entry>

            <entry>f5</entry>
          </row>
        </tfoot>

        <tbody>
          <row>
            <entry>b1</entry>

            <entry>b2</entry>

            <entry>b3</entry>

            <entry>b4</entry>

            <entry morerows="1" valign="middle"><para><!--Pernicous Mixed Content-->
            Vertical Span</para></entry>
          </row>

          <row>
            <entry>c1</entry>

            <entry morerows="1" spanname="bspan" valign="bottom">Span
            Both</entry>

            <entry>c4</entry>
          </row>

          <row>
            <entry>d1</entry>

            <entry>d4</entry>

            <entry>d5</entry>
          </row>
        </tbody>
      </tgroup>
    </table>

    <informaltable frame="none">
      <tgroup cols="2">
        <colspec colwidth="0.5in"/>

        <colspec colwidth="0.5in"/>

        <tbody>
          <row>
            <entry>1</entry>

            <entry>1</entry>
          </row>

          <row>
            <entry>2</entry>

            <entry>4</entry>
          </row>

          <row>
            <entry>3</entry>

            <entry>9</entry>
          </row>
        </tbody>
      </tgroup>
    </informaltable>
  </sect1>

</article>
`;



const SAMPLE3 =
`<?xml version="1.0" encoding="utf-8"?>
<supplement>
  <header>
    <model>B787</model>
    <applicableTo>FCOM</applicableTo>
    <number>B787 24/19</number>
    <cancelling>N/A</cancelling>
    <effectiveDate>September 13, 2024</effectiveDate>
  </header>
  <title>Leading Edge Outboard Slat Actuator Upgrade</title>
  <sectionLevel1>
    <title>Purpose</title>
    <para>To advise flight crew that aircraft upgraded with new leading edge
    outboard slat lockout actuators (LEOLAs) no longer require the flaps and
    slats to remain extended after landing under certain conditions.</para>
  </sectionLevel1>
  <sectionLevel1>
    <title>Background</title>
    <para>An FAA AD was issued after several leading edge outboard slat geared
    rotary actuators (GRAs) failed after the flaps were retracted with ice under
    the leading edge slats.</para>
  </sectionLevel1>
  <sectionLevel1>
    <title>Aircraft upgrades</title>
    <para>LE OB slat GRAs will progressively be upgraded with a lockout actuator
    during scheduled maintenance.</para>
  </sectionLevel1>
  <sectionLevel1>
    <title>Operations</title>
    <para>Aircraft fitted with the new LEOLA’s will have the following NTC in the
    eLog:</para>
    <mediaObject>
      <image fileref="/graphics/00/00/00/1D/G0000001D4F/MAIN.png"/>
    </mediaObject>
  </sectionLevel1>
  <signatureBlock>
    <SME>
      <signedBy>Philip Kirk</signedBy>
      <title>Boeing Tech Pilot</title>
    </SME>
    <checked>
      <signedBy>Michael Billett</signedBy>
      <title>Senior Fleet Manager B787/B777</title>
    </checked>
    <operationalReview>
      <signedBy>Andrew Hanley</signedBy>
      <title>Senior Manager Aircraft Operations</title>
    </operationalReview>
    <approved>
      <signedBy>Hugh Pearce</signedBy>
      <title>Head of Operations</title>
    </approved>
  </signatureBlock>
</supplement>
`;

/* http://localhost:3000/api/fs/graphics/00/00/00/1D/G0000001D4F/MAIN.png */

const TEMPLATE1 =
`<?xml version="1.0" encoding="utf-8"?>
<supplement>
  <header>
    <model></model>
    <applicableTo></applicableTo>
    <number></number>
    <cancelling>N/A</cancelling>
    <effectiveDate></effectiveDate>
  </header>
  <title></title>
  <sectionLevel1>
    <title></title>
    <para></para>
  </sectionLevel1>
  
  <signatureBlock>
    <SME>
      <signedBy></signedBy>
      <title></title>
    </SME>
    <checked>
      <signedBy></signedBy>
      <title></title>
    </checked>
    <operationalReview>
      <signedBy></signedBy>
      <title></title>
    </operationalReview>
    <approved>
      <signedBy></signedBy>
      <title></title>
    </approved>
  </signatureBlock>
</supplement>
`;

function MediaFileChooser(props) {
  const {
    open,
    onCancel,
    onSave,
    title='Choose Graphics',
    node,
    ...other
  } = props;

  const [sizes, setSizes] = useState([100, '25%', 'auto']);
  // const [url, setUrl] = useState('');
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [filteredImages, setFilteredImages] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [categSelection, setCategSelection] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedGlobalIndex, setSelectedGlobalIndex] = useState(-1);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageName, setSelectedImageName] = useState('');
  const [selectedImageLabel, setSelectedImageLabel] = useState('');
  const theme = useTheme();

  useEffect( () => {
    if ( open ) {
      netGet('/api/catalog/categ')
        .then( response => response.json() )
        .then( categs => {
          if ( Array.isArray(categs) ) {
            setCategories(categs);
            // console.log('Media categoeries: ' + JSON.stringify(categs));
          }
        }).catch( error => console.log('Failed to retrieve categories: ' + error));
      const cs = [...categSelection];
      const cats = cs.map(id => {
        const i = id.indexOf('-');
        if ( i >= 0 && i < id.length - 1) {
          const c = id.substring(i+1);
          // console.log('cat=' + c);
          return c;
        }
        return id;
      }).reduce((a, b) => a.length > 0 ? a + ',' + b : b, '');
      // const cat = cs.map(i => categories[i]).reduce((a, b) => a.length > 0 ? a + ',' + b.name : b.name, '');
      setSelectedIndex(-1);
      setSelectedImage(null);
      setSelectedImageLabel('');
      netGet('/api/catalog/image'  + (cs.length > 0 ? '?cat=' + encodeURIComponent(cats) : '') )
        .then(response => response.json())
        .then(data => {
          if (Array.isArray(data)) {
            setImages(data);
            const simage = loadNode();
            if ( simage[0] && simage[0] !== '') {
              let imageIndex = data.findIndex( img => img.name === simage[0]) ;
              if ( imageIndex >= 0 ) {
                // setImages(data);
                const image = data[imageIndex];
                setSelectedImage(image);
                setSelectedImageLabel(image.label);
                setSelectedIndex(imageIndex);
              } else {
                netGet('/api/catalog/image?name=' + encodeURIComponent(simage[0]))
                  .then(response => response.json())
                  .then(data2 => {
                    if ( Array.isArray(data2) ) {
                      // const images = [...data, ...data2];
                      // setImages(images);
                      imageIndex = data2.findIndex(img => img.name === simage[0]);
                      if (imageIndex >= 0) {
                        // console.log('images length=' + images.length + ' : ' + imageIndex);
                        const image = data2[imageIndex];
                        setSelectedImage(image);
                        setSelectedImageLabel(image.label);
                        // setSelectedIndex(imageIndex);
                      }
                    }
                  }).catch(error => console.log('Failed to retrieve image info: ' + error));
              }
            } else {
              setSelectedImage(null);
              setSelectedImageName('');
              setSelectedImageLabel('');
            }
            loadFilteredImages(searchTerm, data);
          }
        }).catch(error => console.log('Failed to retrieve image info: ' + error));
      
      // setCategSelection([]);
    }

  },[open,node]);

  /*
  useEffect( () => {
    if ( Array.isArray(node) ) {
      // console.log('Selected node: ' + JSON.stringify(node));
      const i = node.findIndex( t => t === 'fileref');
      if ( i >= 0 && i<node.length - 1) {
        const fr = node[i+1];
        if ( fr ) {
          const fre = fr.match(/\/(.*?)\/MAIN/);
          if ( Array.isArray(fre) && fre.length > 0 ) {
            let iname = fre[1];
            const j = iname.lastIndexOf('/');
            if ( j >= 0 && j < iname.length-1 ) {
              iname = iname.substring(j+1);
            }
            console.log('Selected image: ' + iname);
            setSelectedImageName(iname);

          }
        }
      }
    }

  },[node]);
  */

  const loadNode = () => {
    if ( Array.isArray(node) ) {
      // console.log('Selected node: ' + JSON.stringify(node));
      const i = node.findIndex( t => t === 'fileref');
      if ( i >= 0 && i<node.length - 1) {
        const fr = node[i+1];
        if ( fr ) {
          const fre = fr.match(/\/(.*?)\/MAIN/);
          if ( Array.isArray(fre) && fre.length > 0 ) {
            let iname = fre[1];
            const j = iname.lastIndexOf('/');
            if ( j >= 0 && j < iname.length-1 ) {
              iname = iname.substring(j+1);
            }
            // console.log('Selected image: ' + iname);
            setSelectedImageName(iname);
            return [iname, null];
          }
        }
      }
    }
    return [null, null];
  };

  const loadFilteredImages = (term, timages) => {
    const lterm = typeof term === 'string' ? term.toLowerCase().trim() : '';
    let fimages = [...timages];
    // console.log('lterm: ' + lterm + ' : ' + fimages.length);
    if ( lterm && lterm !== '') {
      fimages = timages.filter( img => {
        const lname = typeof img.name === 'string' ? img.name.toLowerCase() : '';
        const llabel = typeof img.label === 'string' ? img.label.toLowerCase() : '';
        return lname.includes(lterm) || llabel.includes(lterm);
      });
    }
    setFilteredImages(fimages);
  };

  const debouncedSearchTermChangeHandler = React.useCallback(
        debounce((value, timages) => {
            // Perform your action here with the debounced value
            // console.log('Debounced value:', value);
            loadFilteredImages(value, timages);
            setSearchTerm(value);
        }, 1500), // Debounce delay in milliseconds
        []
    );

  const searchTermChange = (event) => {
    // setSearchTerm(event.target.value);
    debouncedSearchTermChangeHandler(event.target.value, images);
  }

  const onClose = () => {
    onCancel();
  };

  const onCancelClick = () => {
    if ( typeof onCancel === 'function') {
      onCancel();
    }
  };

  const onOKClick = () => {
    if ( typeof onSave === 'function') {
      // onSave(url);
      console.log('selectedImage: ' + JSON.stringify(selectedImage));
      const url = selectedImage ? selectedImage.path + '/MAIN' + getImageExtension(selectedImage) : null;
      onSave(url, selectedImage);
    }
  };

  const categItemsChange = (event, itemIds) => {
    if ( Array.isArray(itemIds) ) {
      setCategSelection(itemIds);
      setSelectedImage(null);
      setSelectedIndex(-1);
      const cats = itemIds.map(id => {
        const i = id.indexOf('-');
        if ( i >= 0 && i < id.length - 1) {
          const c = id.substring(i+1);
          // console.log('cat=' + c);
          return c;
        }
        return id;
      }).reduce((a, b) => a.length > 0 ? a + ',' + b : b, '');
      console.log('itemIds=' + JSON.stringify(itemIds) + ', cat=' + cats);
      netGet('/api/catalog/image' + (itemIds.length > 0 ? '?cat=' + encodeURIComponent(cats) : ''))
        .then(response => response.json())
        .then(data => {
          if (Array.isArray(data)) {
            setImages(data);
            if (selectedImageName && selectedImageName !== '') {
              const imageIndex = data.findIndex(img => img.name === selectedImageName);
              if (imageIndex >= 0) {
                // setImages(data);
                const image = data[imageIndex];
                setSelectedImage(image);
                setSelectedImageLabel(image.label);
                setSelectedIndex(imageIndex);
              }
            }
            loadFilteredImages(searchTerm, data);
          }
        }).catch(error => console.log('Failed to retrieve image info: ' + error));
    }
  };

  const handleCategClick = (categ, index) => {
    const cs = [...categSelection];
    if ( cs.includes(index) ) {
      const j = cs.findIndex( item => item === index);
      if ( j >= 0 ) {
        cs.splice(j, 1);
      }
    } else {
      cs.push(index);
    }
    setCategSelection(cs);
    setSelectedImage(null);
    setSelectedIndex(-1);
    const cat = cs.map(i => categories[i]).reduce((a, b) => a.length > 0 ? a + ',' + b.name : b.name, '');
    netGet('/api/catalog/image' + (cs.length > 0 ? '?cat=' + encodeURIComponent(cat) : ''))
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data)) {
          setImages(data);
          if (selectedImageName && selectedImageName !== '') {
            const imageIndex = data.findIndex(img => img.name === selectedImageName);
            if (imageIndex >= 0) {
              // setImages(data);
              const image = data[imageIndex];
              setSelectedImage(image);
              setSelectedImageLabel(image.label);
              setSelectedIndex(imageIndex);
            }
          }
        }
      }).catch(error => console.log('Failed to retrieve image info: ' + error));
  };

  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setSelectedIndex(index);
    setSelectedImageName(image.name);
    setSelectedImageLabel(image.label);
    // console.log('Selected Image: ' + JSON.stringify(image));
  };

  const getImageExtension = (image) => {
    const t = image.type;
    if ( t.includes('png') ) {
      return '.png';
    }
    if ( t.includes('jpeg') ) {
      return '.jpg';
    }
    if ( t.includes('pdf')) {
      return '.pdf';
    }
    if ( t.includes('gif') ) {
      return '.gif';
    }
    if ( t.includes('svg') ) {
      return '.svg';
    }
  }

  const getImageUrl = (image) => {
    // thumbnail is always PNG
    const url = new URL('/api/fs' + image.path + '/THUMB.png', window.location.href);
    return url.toString();
  }
  const itemTemplate = (item, layout, index) => {
    const selected = item.name === selectedImageName;
    return (
      <Tooltip title={
        <Box>
          <Typography sx={{ fontWeight: 'bold' }}>{item.name}</Typography>
          <Typography>{item.label}</Typography>
        </Box>
      }>
        <Box sx={{ width: '104px', padding: 0, margin: 0 }}>
          <IconButton onClick={() => handleImageClick(item, index)}
            sx={{
              border: selected ? '3px solid red' : '3px solid transparent', borderRadius: 0,
              backgroundColor: selected ? 'gray' : 'white',
              padding: 0,
              margin: 0,
            }} >
            <img
              style={{ height: '92px', width: '92px', maxHeight: '92px', maxWidth: '92px', opacity: selected ? 0.6 : 1 }}
              src={getImageUrl(item)}
              alt={item.label}
              loading="lazy"
            />
          </IconButton>
          <Typography sx={{ fontSize: '8pt', overflow: 'clip', padding: '4px', textWrap: 'nowrap', textOverflow: 'ellipsis' }}>{item.label}</Typography>
        </Box>
      </Tooltip>
    );
  };

  const listTemplate = (items, layout) => {
    return <Box sx={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', 
      rowGap: '15px', columnGap: '5px', height: '610px', alignContent: 'flex-start'}}>{items.map((item, index) => itemTemplate(item, layout, index))}</Box>;
  };

  /*
    <ImageList sx={{ width: 500, height: 490, padding: 3, overflow: 'visible' }} cols={7} gap={10}>
                {Array.isArray(images) && images.filter( (item,index) => index < 128).map((item,index) => (
                  <Tooltip title={
                    <Box>
                      <Typography sx={{fontWeight: 'bold'}}>{item.name}</Typography>
                      <Typography>{item.label}</Typography>
                    </Box>
                  }>
                  <ImageListItem key={item.name} sx={{width: '92px', height: '104px', maxHeight: '130px'}} 
                    >
                      <IconButton onClick={() => handleImageClick(item, index)} 
                        sx={{border: selectedIndex === index ? '3px solid red' : 'none', borderRadius: 0}} >
                    <img
                      style={{height: '92px', width: '92px', maxHeight: '92px', opacity: selectedIndex === index ? 0.6 : 1}}
                      src={getImageUrl(item)}
                      alt={item.label}
                      loading="lazy"
                    />
                    </IconButton>
                    <ImageListItemBar
                      subtitle={item.label}
                      position="below"
                      sx={{fontSize: '8pt', paddingTop: '2px !important', paddingBottom: '2px'}}
                    />
                  </ImageListItem>
                  </Tooltip>
                ))}
              </ImageList>

              , display: 'grid', gridTemplateRows: '2em 1fr' 

<List sx={{padding: 0}} >
                  {Array.isArray(categories) && categories.map((categ, index) =>
                    <ListItem key={`cat-categ-${index}`} disablePadding disableGutters
                      >
                      <ListItemButton onClick={() => handleCategClick(categ, index)} dense disableGutters
                        selected={categSelection.includes(index)} >
                        <ListItemText primary={categ.name} sx={{margin: 0, whiteSpace: 'nowrap'}}/>
                      </ListItemButton>

                    </ListItem>
                  )}
                </List>

                sx={{ maxWidth: '500px' }}
                slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }
                    }}
<Box sx={{width: '100%', height: '3em'}} >
                <TextField
                    
                    onChange={e => setSearchTerm(e.target.value)}
                    id="xxe-search"
                    size="small"
                    
                    
                    
                />
              </Box>
  */

  return (
    <Dialog
      maxWidth={'1200px'}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            minWidth: 1000,
            minHeight: 860,
            maxHeight: 1200
          }
        }
      }}
    >
      <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
      <DialogContent >
        
        <Box sx={{width: '100%', height: '100%', position: 'relative'}}>
          <SplitPane
            style={{minHeight: '3.3em'}}
            split="vertical"
            sizes={sizes}
          >
            <Pane minSize={40} maxSize='60%'>
              <Box sx={{ paddingLeft: 0, paddingTop: 1 }}>
                  <Typography sx={{ fontWeight: 'bold' }}>Category</Typography>
                </Box>
            </Pane>
            <Box sx={{width: '100%', textAlign: 'center'}} >
                <TextField
                    defaultValue={searchTerm}
                    onChange={searchTermChange}
                    id="xxe-search"
                    size="small"
                    type="search"
                    fullWidth
                    sx={{ maxWidth: '500px' }}
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }
                    }}
                />
            </Box>
          </SplitPane>
          <SplitPane
            style={{minHeight: '680px', height: '100%'}}
            split='vertical'
            sizes={sizes}
            onChange={setSizes}
          >
            <Pane minSize={40} maxSize='60%'>
              <Box sx={{ height: '100%', position: 'relative', overflow: 'auto' }}>
                
                <SimpleTreeView multiSelect selectedItems={categSelection} onSelectedItemsChange={categItemsChange}>
                  {Array.isArray(categories) && categories.map((categ, index) =>
                    <TreeItem itemId={`C${index}-${categ.name}`} label={categ.name} />
                  )}
                </SimpleTreeView>
              </Box>
            </Pane>
            <Box sx={{
              height: '100%', position: 'relative', overflow: 'auto', paddingLeft: 1,
              borderLeftColor: theme.palette.divider, borderLeftStyle: 'solid', borderLeftWidth: '2px'
            }} >
              
              <DataView value={filteredImages} listTemplate={listTemplate} layout="grid" paginator rows={24} />
            </Box>
          </SplitPane>
        </Box>
      </DialogContent>
      <DialogActions sx={{ m: 1, display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{display: 'flex'}}>
          <Box>
            <Box sx={{ paddingLeft: 2, width: '8em', fontWeight: 'bold' }}>Selected:</Box>
            <Box sx={{ width: '8em' }}>{'\xa0'}</Box>
          </Box>
            <Box>
              <Box>{selectedImage && selectedImage.name ? selectedImage.name : selectedImageName}</Box>
              <Box>{selectedImage && selectedImage.label ? selectedImage.label : selectedImageLabel}</Box>
            </Box>
            
        </Box>
        <Box sx={{ display: 'inline' }}>
          <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} color="success">OK</Button>
          <Button variant="outlined" onClick={onCancelClick} sx={{ marginLeft: 2, minWidth: '7em' }}>Cancel</Button>
        </Box>
      </DialogActions>
    </Dialog>

);


}

const customWave = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const CustomSkeleton = styled(Skeleton)(({ theme }) => ({
  background: 'linear-gradient(90deg, #f0f0f0 8%, #e0e0e0 18%, #f0f0f0 33%)',
  backgroundSize: '200% 100%',
  animation: `${customWave} 1.5s linear infinite`,
}));

// var mediaChooserOpened = false;
// var mediaChooserUrl = '';
//var mediaChooserImage = null;

/*
let selectedEff = null;
let effCmdMap = {};
*/

function ReactXMLViewer(props) {
  const {
    root,
    name='',
    path,
    du, // document unit as a DocumentNode object
    onSelectionChange,
    onDocumentLoad,
    value,
    ...other
  } = props;
  const [saveNeeded, setSaveNeeded] = useState(false);
  const [opened, setOpened] = useState(false);
  const [editorLabel, setEditorLabel] = useState('');
  const [effList, setEffList] = useState([]);
  const [effTree, setEffTree] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [selectedNode, setSelectedNode] = useState(null);
  const [effMap, setEffMap] = useState({}); // global effectivity map for this document
  const [docEff, setDocEff] = useState({}); // map of xml id to list of effectivities on each element
  const [selectedEff, setSelectedEff] = useState(null); // selected effectivity as reported by backend
  const [prevEff, setPrevEff] = useState(null); // previous selected effectivity 
  const [selectedEffItems, setSelectedEffItems] = useState([]); // selected items in the tree display
  const [expandedEffItems, setExpandedEffItems] = useState([]);
  const [effValue, setEffValue] = useState('');
  const [effDefaultKey, setEffDefaultKey] = useState(''); // default Effectivity key if any
  const [enableEff, setEnableEff] = useState(false);
  // const [effCmdMap, setEffCmdMap] = useState({});
  const [operator, setOperator] = useState('NZ');
  const [docId, setDocId] = useState('');
  const [opening, setOpening] = useState(true);
  const isFormEnabled = useSelector((state) => state.auth.formEnabled);
  
  const editor = useRef(null);
  const theme = useTheme();

  const CLIENT_VERSION = XMLEditorWrapper.CLIENT_VERSION;

  /* serverurl="ws://localhost:18078/xxe/ws" */

  useEffect(() => {
    netGet('/config/realm')
      .then(response => response.json())
      .then(rinfo => {
        if (rinfo?.realm) {
          setOperator(rinfo.realm);
        }
      }).catch(error => {
        console.log('Error fetching realm name: ' + error);
      });
      return () => {
        closeDocument();
      };
  }, []);

  useEffect( () => {
    setEditorLabel(name);
  }, [name]);

  useEffect(() => {
    if (path) {
      setOpened(false);
      setOpening(true);
      /*
      const importComponent = async () => {
          const module = await import('/xxe/xxeclient/xxeclient.js');
          //const AnotherComponent = module.default;
          //setImportedComponent(<AnotherComponent />);
        };
      */
      if (editor.current) {
        // console.log('XML autorecover = ' + editor.current.autoRecover);
        editor.current.autoRecover = false;
        editor.current.resourceStorage = new UcpStorage(editor.current);
        editor.current.addEventListener('connected', editorConnected);
        editor.current.addEventListener('saveStateChanged', editorSaveChanged);
        if (editor.current.connected) {
          openDoc(path);
        } else {
          // console.log('adding event listener...'  + name);

          editor.current.connect().catch(error => console.log('error connecting: ' + error));

        }
      } else {
        console.log('XML Editor not yet mounted!!!');
      }
    }
  }, [path]);

  useEffect(() => {
    if (du) {
      setOpened(false);
      setOpening(true);
      if (editor.current) {
        // console.log('XML autorecover = ' + editor.current.autoRecover);
        editor.current.autoRecover = false;
        editor.current.resourceStorage = new UcpStorage(editor.current);
        editor.current.addEventListener('connected', editorConnected);
        editor.current.addEventListener('saveStateChanged', editorSaveChanged);
        if (editor.current.connected) {
          openDocUnit(du);
        } else {
          // console.log('adding event listener...'  + name);

          editor.current.connect().catch(error => console.log('error connecting: ' + error));

        }
      } else {
        console.log('XML Editor not yet mounted!!!');
      }
    } else {
      closeDocument();
    }

  }, [du]);

  useEffect( () => {
    if ( value !== '' && value !== selectedId && editor.current ) {
      setSelectedId(value);
      moveMarkCmd(false, editor.current.documentView, value);
      
    }
  },[value]);

  const notifySelectionChange = (sel) => {
    if ( typeof onSelectionChange === 'function') {
      onSelectionChange(sel);
    }
  }

  const notifyDocumentLoaded = (content) => {
    if ( typeof onDocumentLoad === 'function' ) {
      // pass the document to caller
      onDocumentLoad(content);
    }
    setOpening(false);
  };

  const moveMarkCmd = (state, docView, param) => {
      if (state) {
        // const selected = getSelectedNode(docView);
        const res = [];
        res.push(true);
        res.push(null);
        res.push(true);
  
        return res;
      }
      docView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.moveMark', param)
          .then( result => {
            if ( result?.value ) {  
              
            }
            return new XXE.CommandResult(XXE.COMMAND_RESULT_DONE);
  
          });
      
  
    };
  
  
  const editorConnected = (event) => {
    console.log('editor connected!');
    if (!opened) {
      if (du) {
        openDocUnit(du);
      } else {
        openDoc(path);
      }
    }
  };

  const editorSaveChanged = (event) => {
    setSaveNeeded(event.saveNeeded);
  };

  const flattenTree = (docId, list, tree, treeList, elist, exp, seq) => {
    if (Array.isArray(tree)) {
      tree.forEach(eff => {
        list.push(eff);
        const m = eff.data?.item?.group ? eff.data?.item?.group : eff.data?.item?.stmt;
        if (m) {
          const index = seq[0];
          const sindex = '' + index;
          const item = {
            key: getRandomKey7() + sindex,
            namespace: m.namespace,
            document: docId,
            documentId: eff.data?.doc?.id,
            value: eff.data?.ename,
            label: eff.data?.title ? eff.data.title : eff.data?.ename,
            // select: typeof eff.data?.select === 'boolean' ? eff.data.select : true,
            select: true,
            tail: false,
            valueSortKey: 'S' + decimalToHexString(index, 5),
            colorValue: eff.data?.color,
            equation: eff.data?.item?.group ? m.label : m.equation,
          }
          // console.log('key: ' + item.key + ' > ' + sindex.length + ' > ' + item.key.length);
          elist.push(item);
          const titem = {
            key: item.key,
            data: item,
            label: item.label,
            value: item.value,
            children: [],
          };
          treeList.push(titem);
          seq[0] = index + 1;
          if (Array.isArray(eff.children) && eff.children.length > 0) {
            exp.push(item.key);
            flattenTree(docId, list, eff.children, titem.children, elist, exp, seq);
          }
        }
      });
    }
  };

  const documentViewChanged = (event) => {
    
  };

  const editingContextChanged = (event) => {
    // console.log('editingContextChanged: event= ' + JSON.stringify(event.nodePathItems));
    
    if ( editor.current.documentView ) {
      let done = false;
      const st = editor.current['uxState'];
      st.selectedNode = null;
      setSelectedNode(null);
      if (Array.isArray(event.nodePathItems)) {
        const n = event.nodePathItems.findIndex( item => item.startsWith('sel'));
        let nitem = null;
        if ( n >= 0 ) {
          nitem = event.nodePathItems[n];
          const tag = event.nodePathItems[n-1];
          if ( tag === '#text' ) {
            if ( n - 2 >= 0 ) {
              nitem = event.nodePathItems[n-3];
            }
          }
        }
        // const nitem = event.nodePathItems.find(n => n.startsWith('sel'));
        // console.log('editingContextChanged: event selection = ' + JSON.stringify(nitem));
        done = true;
        if (nitem) {
          const tokens = nitem.split('\n');
          st.selectedNode = tokens;
          setSelectedNode(tokens);
          // console.log('Tokens: ' + JSON.stringify(tokens));
          const i = tokens.findIndex(s => s === 'id');
          if (i >= 0 && i < tokens.length - 1) {
            const id = tokens[i + 1];
            // console.log('sel id = ' + id);
            if (id !== st.selectedId) {

              st.selectedId = id;
              setSelectedId(id);
              notifySelectionChange(id);
              
              setEnableEff(true);
              if (st.docEff) {
                const eff = st.docEff[id];
                if (eff) {

                  setSelectedEff(eff);
                  setPrevEff(eff);
                  st.selectedEff = eff;
                  if (Array.isArray(eff.effectivity)) {
                    if (eff.effectivity.length > 0) {
                      eff.effectivity.sort((a, b) => a.valueSortKey.localeCompare(b.valueSortKey));
                      const v = eff.effectivity.reduce((sum, current) => sum !== '' ? sum + ',' + current.label : current.label, '');
                      setEffValue(v);
                      const ids = eff.effectivity.map(e => e.key);
                      setSelectedEffItems(ids);
                    } else if (st.defaultEff) {
                      // const defEff = effMap[effDefaultKey];
                      // console.log('DEF KEY: ' + st.defaultEff.key + ' ' + JSON.stringify(st.defaultEff));

                      setEffValue(st.defaultEff.label);
                      setSelectedEffItems([st.defaultEff.key]);
                      setPrevEff(null);
                    } else {
                      setEffValue('');
                      setSelectedEffItems([]);
                      setPrevEff(null);
                    }
                  } else {
                    setEffValue('');
                    setSelectedEffItems([]);
                    setPrevEff(null);
                  }
                } else {
                  setEffValue('');
                  setSelectedEffItems([]);
                  setPrevEff(null);
                }
              } else {
                setEffValue('');
                setSelectedEffItems([]);
                setPrevEff(null);
              }
              
            } // if is new id
            // if id present
          } else {
            // console.log('sel no id!');
            if (st.selectedId !== '') {
              st.selectedId = '';
              setSelectedId('');
              setEffValue('');
              setSelectedEffItems([]);
              setPrevEff(null);
            }
          }
        } else {
          if (st.selectedId !== '') {
            st.selectedEff = null;
            st.selectedId = '';
            st.selectedNode = null;
            setSelectedId('');
            setEffValue('');
            setSelectedEffItems([]);
            setSelectedEff(null);
            setPrevEff(null);
            setEnableEff(false);
          }
        }
      }
      
    }
  };


  const openDocUnit = (dunit) => {
    const entry = dunit?.entry ? dunit.entry : {};
    const dpath = dunit.rootPath + '/' + entry.contentPath;
    if (editor.current) {
      editor.current.removeEventListener('documentViewChanged', documentViewChanged);
      if ( editor.current.uxToolBar ) {
        editor.current.uxToolBar.style.display = 'none';
      }
    }
    // openDoc(dpath);
    netGet('/api/doc/entry/content/' + entry.entryId)
      .then( response => response.json())
      .then(info => {

        const config = info.config;
        let nodes = config?.properties?.eff?.source ? config.properties.eff.source : [];
        if (!Array.isArray(nodes)) {
          nodes = [];
        }
        const flist = [];
        const treeList = [];
        let elist = [];
        const seq = [0];
        const exp = [];
        flattenTree(info.docId, flist, nodes, treeList, elist, exp, seq);
        
        const emap = {};
        const smap = {};
        elist.forEach(item => {
          emap[item.key] = item;
          smap[item.value] = item;
        });
        setEffDefaultKey(null);
        
        setExpandedEffItems(exp);
        setEffTree(treeList);
        setEffList(elist);
        setEffMap(emap);
        const deff = {};
        if ( info.metadata && Array.isArray(info.metadata.tables) ) {
          const effTable = info.metadata.tables.find( t => t.name === 'Effectivity');
          if ( Array.isArray(effTable?.entries) ) {
            effTable.entries.forEach( e => {
              let eentry = deff[e.id];
              if ( !eentry ) {
                eentry = {
                  id: e.id,
                  effectivity: [],
                };
              }
              const eff = smap[e.statement];
              if ( eff ) {
                eentry.effectivity.push(eff);
              }
              deff[e.id] = eentry;
            });
          }
        }
        setDocEff(deff);
        

        setOpened(true);
        setTimeout(() => {
          if (editor.current) {
            editor.current?.addEventListener('contextmenu', (event) => {
              event.preventDefault();
              event.stopImmediatePropagation();
              event.stopPropagation();
              // console.log('xviewer INTERSECTED: contextmenu');
            });
            editor.current.removeEventListener('documentViewChanged', documentViewChanged);
            if (editor.current.uxToolBar) {
              editor.current.uxToolBar.style.display = 'none';
            }
          }
            closeDocument().then(() => {
              console.log('opening viewer doc: ' + dpath);
              if ( root ) {
                console.log('Setting shadowRoot: ' + root);
                editor.current.documentView.domTree = root;
              } else {
                console.log('NO shadowRoot FOUND!');
              }
              if ( editor.current ) {
                editor.current.removeEventListener('documentViewChanged', documentViewChanged);
                if (editor.current.uxToolBar) {
                  editor.current.uxToolBar.style.display = 'none';
                }
              }
              // setOpening(false);
              editor.current?.openDocument(info.content, new URL(dpath, window.location.href).toString(), true)
                .then( () => {
                  
                  if ( Array.isArray(elist) ) {
                    
                    let oldDisplay = editor.current.uxToolBar.style.display;
                    
                    editor.current.uxToolBar.style.display = 'none';
                    const statusPane = editor.current.uxStatusPane;
                    if ( statusPane ) {
                      statusPane.style.display = 'none';
                    }

                    editor.current['uxState'] = {
                      effCmdMap: {},
                      selectedEff: null,
                      docMeta: info.metadata,
                      defaultEff: null,
                      docEff: deff,
                      selectedId: null,
                      selectedNode: null, // array of selected node path 
                      views: null, // cache of views seen in the document
                      oldDisplay: oldDisplay,
                      mediaChooserOpened: false,
                      mediaChooserUrl: '',
                      opening: false,
                    };
                    
                    const dinfo = {
                      docId: info.document?.id,
                      title: info.document?.title,
                      tenantId: info.document?.operator,
                      effectivityNamespace: info.document?.namespace,
                      idChannel: info.document?.idChannel,
                      configBaseKey: info.document?.configBaseKey,
                      effectivityConfig: elist,
                      effectivityMap: deff,
                    };
                    setDocId(info.document?.id);
                    // editor.current.documentView.magicX = 233;
                    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.loadDocumentContext', JSON.stringify(dinfo));
                    editor.current.removeEventListener('editingContextChanged', editingContextChanged);
                    editor.current.addEventListener('editingContextChanged', editingContextChanged);
                    editor.current.removeEventListener('documentViewChanged', documentViewChanged);
                    editor.current.removeEventListener('documentViewChanged', documentViewChanged);
                    editor.current.addEventListener('documentViewChanged', documentViewChanged);
                    if ( value ) {
                      moveMarkCmd(false,editor.current.documentView, value);
                    }
                    
                    /*
                    const binding1 = editor.current.documentView.getAppEventBinding('resize-image');
                    console.log('resize-image binding: ' + JSON.stringify(binding1));
                    const binding2 = editor.current.documentView.getAppEventBinding('rescale-image');
                    console.log('rescale-image binding: ' + JSON.stringify(binding2));
                    */
                  }
                  notifyDocumentLoaded(info.content);
                  setOpening(false);
                  
                })
                .catch(error => {
                  console.log('Error opending document entry: ' + error);
                  editor.current.openDocument(TEMPLATE1, new URL(dpath, window.location.href).toString());
                });
            });
          
        }, 500);

      }).catch(error => console.log('Error opening document entry ' + error));
  };

  const openDoc = (path) => {
    if (editor.current) {
      netGet('/api/fs' + path)
        .then(response => response.text())
        .then(text => {
          // console.log('text: ' + text);
          setOpened(true);
          setTimeout(() => {
            if (text.includes('<description')) {
              closeDocument().then(() => {
                editor.current.openDocument(TEMPLATE1, new URL(path, window.location.href).toString());
              });
            } else {
              closeDocument().then(() => {
                editor.current.openDocument(text, new URL(path, window.location.href).toString()).catch(error => {
                  console.log('Error opending document: ' + error);
                  editor.current.openDocument(TEMPLATE1, new URL(path, window.location.href).toString());
                  setOpening(false);
                });
              });
            }
          }, 500);

        }).catch(error => console.log('Error opening document ' + error));
    }
  };

  class UcpResource extends XXE.Resource {
    constructor(uri, data) {
      super(uri, data);
    }
  }
    
  class UcpStorage extends XXE.ResourceStorage {

    constructor(xmlEditor) {
      super(xmlEditor);
    }

    async loadResource(uri) {
      /*
      let p = uri;
      let url = `/api/fs/${p}`;
      if (uri.startsWith('catalog:/')) {
        p = uri.substring(10);
        url = `/api/fs/catalog/${p}`;
      } else if ( uri.startsWith('media:/') ) {
        p = uri.substring(8);
        url = `/api/fs/${p}`;
      }
      */
      const url = new URL(uri);
      const purl = url.pathname.startsWith('/api/fs/') ? url.pathname : '/api/fs' + url.pathname;

      // console.log('Loading resource: ' + purl);
      const resp = await netGet(purl);
      const data = await resp.blob();
      return new UcpResource(uri, data);
    }


    async openResource(options) {
      // console.log('openResource options: ' + JSON.stringify(options));
      return null;
    }
  }


  const closeDocument = () => {
    console.log('XMLViewer call closeDocument');
    setOpening(true);
    if (!editor.current?.documentIsOpened) {
      return Promise.resolve(true);
    } else {
      console.log('XMLViewer closed document');
      if (editor?.current) {
        const r = editor.current.closeDocument(/*discardChanges*/ true);
        editor.current.disconnect();
        return r;
      }
      return Promise.resolve(true);
    }

  };

  


  /* serverurl="ws://localhost:18078/xxe/ws" */
  /* height: 100%  <Typography sx={{fontStyle: 'italic', zIndex: '200'}}> */
  return (
    <Box sx={{ height: '100%', display: 'block', position: 'relative' }}>
      <React.Fragment>
          {isFormEnabled ?
            (<Paper component="ux-xxe-client-wrapper" elevation="0" ref={editor} sx={{ height: '100%', position: 'relative', width: '100%' }}
              serverurl="ws://localhost:18078/xxe/ws" readonly >
            </Paper>) :
            (<Paper component="ux-xxe-client-wrapper" elevation="0" ref={editor} sx={{ height: '100%', position: 'relative', width: '100%' }} readonly >
            </Paper>)
          }
          <Box sx={{position: 'absolute', top: '0', zIndex: '100', opacity: '1', visibility: opening ? 'visible' : 'hidden', height: '100%', width: '100%', 
              backgroundColor: 'white', padding: '10px'}} >
            <CustomSkeleton variant="rounded" animation="wave" width="100%" height="100%" sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', fontStyle: 'italic'}} >
              Loading...
            </CustomSkeleton>
          </Box>
      </React.Fragment>)
      
    </Box>
  );
}

export { ReactXMLViewer };